/* eslint-disable camelcase */
import * as veeValidate from 'vee-validate';
import { all as veeValidateRules } from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';
import { rules } from '@/plugins/vee-validate/rules.js';

const { configure, defineRule } = veeValidate;

configure({
  generateMessage: localize('pt_BR', {
    messages: {
      required: 'Este campo é obrigatório',
      email: 'Digite um email válido',
      phone: 'Digite um telefone válido',
      cep: 'Digite um CEP válido',
      cnpj: 'Digite um CNPJ válido',
      min: 'Mínimo de {length} caracteres',
      document: 'O campo {field} não é um documento válido',
      cpf: 'O campo {field} não é um CPF válido',
      url: 'O campo {field} não é uma URL válida',
      accepted: 'O campo {field} precisa ser aceito',
      not_accepted: 'O campo {field} não foi selecionado corretamente',
      password: 'As senhas digitadas não são iguais',
      required_radio: 'O campo {field} é obrigatório',
    },
  }),
  validateOnInput: true,
});

Object.keys(veeValidateRules).forEach((rule) => {
  defineRule(rule, veeValidateRules[rule]);
});

Object.keys(rules).forEach((rule) => {
  defineRule(rule, rules[rule]);
});

export default veeValidate;